/*
 * load-more.js — Baksteendirect
 * Lean "Meer weergeven" (show more) pagination for the collection and search grids.
 * Fetches the next page, appends its grid items to the current grid and swaps in
 * the next button. No infinite scroll, no third-party code.
 */
if (!customElements.get('load-more-button')) {
  customElements.define(
    'load-more-button',
    class LoadMoreButton extends HTMLElement {
      constructor() {
        super();
        this.link = this.querySelector('a');
        this.loading = false;
        if (this.link) {
          this.link.addEventListener('click', this.onClick.bind(this));
        }
      }

      onClick(event) {
        event.preventDefault();
        if (this.loading) return;
        this.loadNext();
      }

      setLoading(state) {
        this.loading = state;
        const label = this.querySelector('.js-load-more-label');
        const spinner = this.querySelector('.js-load-more-spinner');
        if (label) label.classList.toggle('hidden', state);
        if (spinner) spinner.classList.toggle('hidden', !state);
        if (this.link) this.link.setAttribute('aria-busy', state ? 'true' : 'false');
      }

      async loadNext() {
        const url = this.dataset.url;
        const gridId = this.dataset.grid || 'product-grid';
        if (!url) return;

        this.setLoading(true);

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error(response.status);
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');

          const currentGrid = document.getElementById(gridId);
          const newGrid = doc.getElementById(gridId);
          if (currentGrid && newGrid) {
            const items = newGrid.querySelectorAll('.grid__item');
            items.forEach((item) => currentGrid.appendChild(item));
          }

          // Swap in the next button (or remove it on the last page).
          const newLoadMore = doc.querySelector('load-more-button');
          if (newLoadMore && newLoadMore.dataset.url) {
            this.dataset.url = newLoadMore.dataset.url;
            if (this.link) this.link.setAttribute('href', newLoadMore.dataset.url);
            this.setLoading(false);
          } else {
            const wrapper = this.closest('.pagination-wrapper');
            if (wrapper) {
              wrapper.remove();
            } else {
              this.remove();
            }
          }

          // Re-init scroll-reveal animations if the theme uses them.
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger();
          }
        } catch (error) {
          // On failure fall back to a normal page navigation.
          window.location.href = url;
        }
      }
    }
  );
}
